/**
 * Accordion group: one-open-at-a-time.
 * Animation is handled entirely by CSS max-height transition.
 */
(function () {
  function initGroup(grid) {
    const accordions = grid.querySelectorAll('.accordion');

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector('.accordion__summary');

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = accordion.hasAttribute('open');

        accordions.forEach((other) => {
          if (other !== accordion) other.removeAttribute('open');
        });

        if (isOpen) {
          accordion.removeAttribute('open');
        } else {
          accordion.setAttribute('open', '');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.product-accordions__grid').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
